import { useMemo, useState } from "react";
import { useCie10Catalog } from "./useCie10Catalog";

type Props = {
  code: string;
  description: string;
  onSelect: (code: string, description: string) => void;
  invalid?: boolean;
};

export function Cie10Search({ code, description, onSelect, invalid }: Props) {
  const [query, setQuery] = useState(description);
  const [open, setOpen] = useState(false);
  const { data, isLoading } = useCie10Catalog(open || query.length >= 2);

  const results = useMemo(() => {
    if (!data || query.length < 2) return [];
    const q = query.toLowerCase();
    return data.filter((it) => it.code.toLowerCase().includes(q) || it.desc.toLowerCase().includes(q)).slice(0, 15);
  }, [data, query]);

  return (
    <div className="cie10-search" onBlur={(e) => {
      if (!e.currentTarget.contains(e.relatedTarget as Node)) setOpen(false);
    }}>
      <div className="cie10-input-row">
        <input
          type="text"
          value={query}
          onChange={(e) => { setQuery(e.target.value); setOpen(true); }}
          onFocus={() => setOpen(true)}
          placeholder="Escribe código o descripción (mín. 2 chars)"
          aria-invalid={invalid}
          className={invalid ? "campo-requerido-error" : ""}
        />
        {code && <span className="cie10-code-badge">{code}</span>}
      </div>
      {open && query.length >= 2 && (
        <div className="cie10-dropdown">
          {isLoading && <div className="cie10-item cie10-item--muted">Cargando catálogo…</div>}
          {!isLoading && results.length === 0 && (
            <div className="cie10-item cie10-item--muted">Sin resultados para "{query}"</div>
          )}
          {results.map((item) => (
            <button
              key={item.code}
              type="button"
              className="cie10-item"
              onMouseDown={(e) => {
                e.preventDefault();
                onSelect(item.code, item.desc);
                setQuery(item.desc);
                setOpen(false);
              }}
            >
              <span className="cie10-item-code">{item.code}</span>
              <span className="cie10-item-desc">{item.desc}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
